var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"policy",domProps:{"innerHTML":_vm._s(_vm.coreParams.privacy)}})]),(_vm.hasPoweredBy)?_c('powered-by'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }